import React from 'react';
import { tokens } from '@domain-group/fe-brary';
import { Star } from '../star';
import * as styles from './index.styles';

const { colors } = tokens;

type StarRatingProps = {
  fillBackground?: string;
  fillStar?: string;
  rating: number;
  maxRating?: number;
  starSize?: number;
  starGap?: number;
};

export function StarRating({
  fillBackground = 'none',
  fillStar = colors.warning.base.default,
  rating,
  maxRating = 5,
  starSize = 20,
  starGap = 1,
}: StarRatingProps): JSX.Element {
  const getRatingPercents = () => {
    const adjustedFinalRating = Math.min(maxRating, Math.max(rating, 0));
    const totalFullStars = Math.floor(adjustedFinalRating);
    const starFraction =
      adjustedFinalRating % 1 === 0 ? 0 : (adjustedFinalRating % 1) * 100;

    return [
      ...Array(totalFullStars).fill(100),
      starFraction,
      ...Array(maxRating).fill(0),
    ].slice(0, maxRating);
  };

  return (
    <div css={styles.starRating(starGap)}>
      {getRatingPercents().map((percentage, starIndex) => {
        const key = `star-${starIndex}`;
        return (
          <span css={styles.starWrapper} key={key}>
            <Star
              fillBackground={fillBackground}
              percentage={percentage}
              fillStar={fillStar}
              size={starSize}
            />
          </span>
        );
      })}
    </div>
  );
}

export default StarRating;
